import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        homeData: null,
        loading: true,
        lightNavbar: false,
        activeSection: 'home',
    },
    mutations: {
        SET_HOME_DATA(state, payload){
            state.homeData = payload.data;
        },
        SET_LOADING(state, loading){
            state.loading = !!loading;
        },
        SET_LIGHT_NAVBAR(state, light){
            state.lightNavbar = !!light;
        },
        SET_ACTIVE_SECTION(state, section){
            state.activeSection = section;
        },
    },
    actions: {
        loadHomeData({commit}){
            return window.axios.get('/home').then(response=>{
                commit('SET_HOME_DATA', {data: response.data});
            })
        }
    },
    modules: {}
});
